<template>
  <header class="site-header flex-col">
    <CertificateResultModal
      :visible="!!certResult"
      :result="certResult"
      @close="certResult = null"
    />
    <div class="site-header__toolbar flex-row">
      <router-link class="site-header__brand flex-row" to="/lanhu_shouye">
        <img
          class="site-header__logo"
          referrerpolicy="no-referrer"
          :src="logoImg"
          alt=""
        />
        <span class="site-header__title">华为数字商城</span>
      </router-link>
      <nav class="site-header__nav flex-row" aria-label="主导航">
        <router-link
          v-for="item in navItems"
          :key="item.to"
          class="site-header__link flex-col"
          :to="item.to"
          :exact="!!item.exact"
          :class="{ 'site-header__link--active': isNavActive(item) }"
        >
          <span class="site-header__link-text">{{ item.label }}</span>
          <span class="site-header__link-bar" aria-hidden="true" />
        </router-link>
      </nav>
      <div class="site-header__end flex-row">
        <router-link
          v-if="!isLoggedIn"
          class="site-header__login"
          :to="{ path: '/web/login', query: { redirect: $route.fullPath } }"
        >
          登录
        </router-link>
        <div class="site-header__search flex-row justify-end">
          <img class="site-header__search-icon" referrerpolicy="no-referrer" :src="searchIcon" alt="" />
          <input
            v-model="certKeyword"
            type="text"
            class="site-header__search-input"
            placeholder="输入证书关键词、编码进行查询"
            :disabled="certLoading"
            @keyup.enter="handleCertQuery"
          />
          <div
            class="site-header__search-btn flex-col"
            role="button"
            tabindex="0"
            @click="handleCertQuery"
            @keyup.enter.prevent="handleCertQuery"
          >
            <span>{{ certLoading ? '查询中...' : '查询' }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { getToken } from '@/utils/auth.js';
import { queryCertificate } from '@/api/cert.js';
import CertificateResultModal from '@/components/CertificateResultModal.vue';
import logoImg from '@/views/lanhu_shouye/assets/img/ak.png';
import searchIcon from '@/views/lanhu_shouye/assets/img/SketchPng4a39754efd6a561ad039631f4319fe83c3f78952b3e9810bcdd22736e16e9590.png';

export default {
  name: 'SiteHeader',
  components: {
    CertificateResultModal
  },
  data() {
    return {
      authTick: 0,
      certKeyword: '',
      certLoading: false,
      certResult: null,
      logoImg,
      searchIcon,
      navItems: [
        { to: '/lanhu_shouye', label: '首页', exact: true },
        { to: '/lanhu_guanyuwomen', label: '关于我们' },
        { to: '/lanhu_zixunzhongxin', label: '资讯中心', news: true },
        { to: '/lanhu_fuwushang', label: '服务商' },
        { to: '/lanhu_fuchizhengce', label: '扶持政策' }
      ]
    };
  },
  computed: {
    isLoggedIn() {
      this.authTick;
      return !!getToken();
    }
  },
  watch: {
    $route() {
      this.authTick++;
    }
  },
  methods: {
    isNavActive(item) {
      const p = this.$route.path;
      if (item.news) {
        return p === '/lanhu_zixunzhongxin' || p.startsWith('/lanhu_zixunzhongxin');
      }
      if (item.exact) {
        return p === item.to;
      }
      return p === item.to || p.startsWith(item.to + '/');
    },
    async handleCertQuery() {
      const sn = (this.certKeyword || '').trim();
      if (!sn) return;
      this.certLoading = true;
      this.certResult = null;
      try {
        const { success, data, message } = await queryCertificate(sn);
        if (success) {
          this.certResult = data;
        } else {
          window.alert(message || '查询失败，请检查证书关键词是否正确');
        }
      } catch (e) {
        window.alert('网络错误，请稍后重试');
      } finally {
        this.certLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.site-header {
  box-shadow: inset 0 -1px 0 0 rgba(224, 225, 230, 1);
  background-color: #fff;
  height: 75px;
  width: 1440px;
  box-sizing: border-box;
}

.site-header__toolbar {
  width: 1280px;
  height: 60px;
  margin: 8px 0 0 80px;
  align-items: center;
}

.site-header__brand {
  text-decoration: none;
  color: inherit;
  align-items: center;
}

.site-header__logo {
  width: 60px;
  flex-shrink: 0;
}

.site-header__title {
  width: 120px;
  height: 28px;
  color: rgba(0, 0, 0, 1);
  font-size: 22px;
  font-family: PingFang-SC-Bold, PingFangSC-Regular, sans-serif;
  line-height: 28px;
  margin: 0 0 0 8px;
  white-space: nowrap;
}

.site-header__nav {
  margin: 0 0 0 50px;
  align-items: flex-start;
  flex-shrink: 0;
}

.site-header__end {
  margin-left: auto;
  align-items: center;
  flex-shrink: 0;
  gap: 16px;
}

.site-header__login {
  flex-shrink: 0;
  font-size: 14px;
  line-height: 20px;
  color: rgba(102, 102, 102, 1);
  text-decoration: none;
  white-space: nowrap;
}
.site-header__login:hover {
  color: rgba(199, 0, 11, 1);
}

.site-header__link {
  text-decoration: none;
  margin-left: 34px;
  min-height: 27px;
  align-items: center;
  &:first-child {
    margin-left: 0;
  }
}

.site-header__link-text {
  font-size: 14px;
  line-height: 20px;
  color: rgba(102, 102, 102, 1);
  white-space: nowrap;
}

.site-header__link-bar {
  width: 28px;
  height: 2px;
  margin-top: 5px;
  background: transparent;
  border-radius: 1px;
}

.site-header__link.site-header__link--active .site-header__link-text {
  color: rgba(199, 0, 11, 1);
}

.site-header__link.site-header__link--active .site-header__link-bar {
  background: rgba(199, 0, 11, 1);
}

.site-header__search {
  background-color: #fff;
  border-radius: 6px;
  width: 298px;
  height: 36px;
  border: 1px solid rgba(214, 214, 214, 1);
  margin: 0;
  flex-shrink: 0;
}

.site-header__search-icon {
  width: 14px;
  height: 14px;
  margin: 11px 0 0 12px;
}

.site-header__search-input {
  flex: 1;
  min-width: 0;
  height: 17px;
  margin: 10px 0 0 6px;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 12px;
  line-height: 17px;
  color: rgba(51, 51, 51, 1);
  outline: none;
}
.site-header__search-input::placeholder {
  color: rgba(185, 187, 192, 1);
}
.site-header__search-input:disabled {
  opacity: 0.7;
}

.site-header__search-btn {
  background-color: rgba(199, 0, 11, 1);
  border-radius: 0 6px 6px 0;
  height: 36px;
  margin-left: auto;
  width: 62px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  span {
    color: #fff;
    font-size: 12px;
    line-height: 17px;
  }
}
</style>
